import { withI18n } from 'panda-i18n';
import locale from '@/locales';
import { CnDynamicForm as CnDynamicFormView } from './view';
CnDynamicFormView.displayName = 'CnDynamicForm';
export var CnDynamicForm = withI18n(CnDynamicFormView, {
    locale: locale,
});
